import React, { useState, useEffect } from "react";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

import CardMedia from '@material-ui/core/CardMedia';

import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import ModalUpdateMessage from "components/ModalUpdateMessage/MessageUpdateMessage";
import ModalDeleteMessage from "components/ModalDeleteMessage/ModalDeleteMessage";



import img0 from "assets/img/products/0.png";
import img1 from "assets/img/products/1.png";
import img2 from "assets/img/products/2.png";
import img3 from "assets/img/products/3.png";
import img4 from "assets/img/products/4.png";
import img5 from "assets/img/products/5.png";
import img6 from "assets/img/products/6.png";
import img7 from "assets/img/products/7.png";
import img8 from "assets/img/products/8.png";
import img9 from "assets/img/products/9.png";
import img10 from "assets/img/products/10.png";
import img11 from "assets/img/products/46.png";
import img12 from "assets/img/products/50010.png";
import img13 from "assets/img/products/50012.png";
import img14 from "assets/img/products/50040.png";
import img15 from "assets/img/products/50041.png";


import api from "assets/services/api.js";
import useAuth from "hooks/useAuth";
import Pagination from '@material-ui/lab/Pagination';

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";

const styles3 = {
  amountbox: {
    fontSize: "14px",
  },
  MT: {
    marginTop: "-13px",
  }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);
const useStyles3 = makeStyles(styles3);


const images = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15]

export default function Dashboard() {

  const { storageId } = useAuth();
  const classes2 = useStyles2();
  const classes3 = useStyles3();

  const [storageOfProducts, setStorageOfProducts] = useState([]);

  const [messageOfSells, setMessageOfSells] = useState([]);
  const [pageSell, setPageSell] = useState(1);
  const [totalPagesSell, setTotalPagesSell] = useState(1);

  const [messageOfStorages, setMessageOfStorages] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [modalShow, setModalShow] = useState(false);
  const [modalShowDelete, setModalShowDelete] = useState(false);
  const [index, setIndex] = useState({ id: 1 });


  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleChangeSell = (event, value) => {
    setPageSell(value);
  };

  async function getStoragesOfProducts() {
    const response = await api.get('/product_client/operator/' + storageId);
    setStorageOfProducts(response.data);
  }

  async function getMessagesofStorage() {
    const response = await api.get('/message/storage/operator/' + storageId + '/' + page);
    setTotalPages(response.data[0]);
    setMessageOfStorages(response.data[1]);
  }

  async function getMessagesofSell() {
    const response = await api.get('/message/sell/operator/' + storageId + '/' + pageSell);
    setTotalPagesSell(response.data[0]);
    setMessageOfSells(response.data[1]);
  }

  async function callModalUpdate(index) {
    if (index.id_storage) {
      index.type = "storage"
    }
    if (index.id_sell) {
      index.type = "sell"
    }
    setIndex(index);
    setModalShow(true);
  }

  async function callModalDelete(index) {
    if (index.id_storage) {
      index.type = "storage"
    }
    if (index.id_sell) {
      index.type = "sell"
    }
    setIndex(index);
    setModalShowDelete(true);
  }

  async function callModalDeleteSell(index) {
    if (index.id_storage) {
      index.type = "storage"
    }
    if (index.id_sell) {
      index.type = "sell"
    }
    setIndex(index);
    setModalShowDelete(true);
  }

  function chooseImage(code, name) {
    switch (code) {
      case '12': {
        return images[0];
      }
      case '15': {
        return images[1];
      }
      case '16': {
        return images[2];
      }
      case '26': {
        return images[3];
      }
      case '27': {
        return images[4];
      }
      case '1': {
        return images[5];
      }
      case '18': {
        return images[6];
      }
      case '11': {
        return images[7];
      }
      case '40': {
        if (name === 'PARMESAO KILO') {
          return images[8];
        } else {
          return images[10];
        }
      }
      case '14': {
        return images[9];
      }
      case '46': {
        return images[11]
      }
      case '50010': {
        return images[12]
      }
      case '50012': {
        return images[13]
      }
      case '50041': {
        return images[15]
      }
      case '50040': {
        return images[14]
      }
      default: {
        return 0
      }

    }
  }

  useEffect(() => {
    getStoragesOfProducts();
  }, [])

  useEffect(() => {
    getMessagesofStorage();
  }, [page])

  useEffect(() => {
    getMessagesofSell();
  }, [pageSell])

  const classes = useStyles();
  return (

    <div>
      <GridContainer>
        {storageOfProducts.map(product => (
          <GridItem key={String(product.img)} xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="warning" stats icon>
                <CardMedia>
                  <img
                    className={classes.imageDash}
                    src={chooseImage(product.code, product.name)}
                    title={product.name}
                    alt={product.name}
                  />
                </CardMedia>
                <p className={classes.cardCategory}>{product.name}</p>
                <h3 className={classes.cardTitle}>
                  {product.weight !== null ? product.weight : product.amount}
                </h3>
                <p className={classes.cardCategory}><div className={classes3.MT}></div> Quantidade em caixas:<b className={classes3.amountbox}> {parseFloat(product.box)}</b></p>
                <p className={classes.cardCategory}> <div className={classes3.MT}></div> Com vendas em andamento:<b className={classes3.amountbox}> {parseFloat(product.amountWithoutSell)}</b> Em caixas:<b className={classes3.amountbox}> {parseFloat(product.boxWithouSell)}</b> </p>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <p>
                    Quantidade deste produto no estoque
                  </p>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        ))}
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Mensagens sobre estoque</h4>
              <p className={classes.cardCategoryWhite}>
                Mensagens que você enviou sobre erros no estoque
              </p>
            </CardHeader>
            <CardBody>
              {messageOfStorages.map(message => (
                <Table
                  tableHeaderColor="warning"
                  tableHead={["Nota fiscal", "Mensagem", "Ações"]}
                  tableData={[
                    [message.nf, message.text,
                    <div className={classes2.tableActions}>
                      <Tooltip
                        id="tooltip-top"
                        title="Editar mensagem"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                      >
                        <IconButton
                          aria-label="Edit"
                          className={classes2.tableActionButton}
                          onClick={() => callModalUpdate(message)}
                        >
                          <Edit
                            className={
                              classes2.tableActionButtonIcon + " " + classes2.edit
                            }

                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        id="tooltip-top"
                        title="Deletar mensagem"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                      >
                        <IconButton
                          aria-label="Close"
                          className={classes2.tableActionButton}
                          onClick={() => callModalDelete(message)}
                        >
                          <Close
                            className={
                              classes2.tableActionButtonIcon + " " + classes2.edit
                            }

                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                    ],
                  ]}
                />
              ))}
              <Pagination count={totalPages} page={page} onChange={handleChange} />
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="warning">
              <h4 className={classes.cardTitleWhite}>Mensagens sobre vendas</h4>
              <p className={classes.cardCategoryWhite}>
                Mensagens que você enviou sobre erros no vendas
              </p>
            </CardHeader>
            <CardBody>
              {messageOfSells.map(message => (
                <Table
                  tableHeaderColor="warning"
                  tableHead={["Nota fiscal", "Mensagem", "Ações"]}
                  tableData={[
                    [message.nf, message.text,
                    <div className={classes2.tableActions}>
                      <Tooltip
                        id="tooltip-top"
                        title="Editar mensagem"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                      >
                        <IconButton
                          aria-label="Edit"
                          className={classes2.tableActionButton}
                          onClick={() => callModalUpdate(message)}
                        >
                          <Edit
                            className={
                              classes2.tableActionButtonIcon + " " + classes2.edit
                            }

                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        id="tooltip-top"
                        title="Deletar mensagem"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                      >
                        <IconButton
                          aria-label="Close"
                          className={classes2.tableActionButton}
                          onClick={() => callModalDeleteSell(message)}
                        >
                          <Close
                            className={
                              classes2.tableActionButtonIcon + " " + classes2.edit
                            }

                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                    ],
                  ]}
                />
              ))}
              <Pagination count={totalPagesSell} page={pageSell} onChange={handleChangeSell} />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <ModalUpdateMessage key={String("MesUp_" + index.id)} props={index} show={modalShow} getMessagesofStorage={getMessagesofStorage} getMessagesofSell={getMessagesofSell}
        onHide={() => setModalShow(false)} />
      <ModalDeleteMessage key={String("MessDel_" + index.id)} props={index} show={modalShowDelete} getMessagesofStorage={getMessagesofStorage} getMessagesofSell={getMessagesofSell}
        onHide={() => setModalShowDelete(false)} />
    </div>
  );
}
